import posthog from 'posthog-js';

const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY;
const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com';

let analyticsInitialized = false;
let analyticsLoaded = false;

export function initializeOptionalAnalytics() {
  if (analyticsInitialized) {
    // Already initialized in this session. Re-enable capture in case it was opted out.
    if (analyticsLoaded) {
      try {
        posthog.opt_in_capturing();
      } catch (_err) {
        // best-effort
      }
    }
    return;
  }

  if (typeof window === 'undefined') return;

  if (!POSTHOG_KEY) {
    // eslint-disable-next-line no-console
    console.info('[ANALYTICS] PostHog disabled - REACT_APP_POSTHOG_KEY missing');
    analyticsInitialized = true;
    return;
  }

  try {
    posthog.init(POSTHOG_KEY, {
      api_host: POSTHOG_HOST,
      capture_pageview: true,
      capture_pageleave: true,
      autocapture: false,
      disable_session_recording: true,
      person_profiles: 'identified_only',
      respect_dnt: true,
      loaded: () => {
        analyticsLoaded = true;
      },
    });
    analyticsInitialized = true;
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('[ANALYTICS] PostHog init failed', err?.message || err);
    analyticsInitialized = true;
  }
}

export function stopOptionalAnalytics() {
  if (!analyticsInitialized || !analyticsLoaded) return;
  try {
    posthog.opt_out_capturing();
  } catch (_err) {
    // best-effort
  }
}

export function trackStudioEvent(eventName, props = {}) {
  if (!analyticsLoaded) return;
  if (!eventName) return;
  try {
    posthog.capture(eventName, props);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('[ANALYTICS] trackStudioEvent failed', err?.message || err);
  }
}

export function trackBoiteLettresEvent(eventName, props = {}) {
  if (!analyticsLoaded) return;
  if (!eventName) return;
  try {
    posthog.capture(eventName, props);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('[ANALYTICS] trackBoiteLettresEvent failed', err?.message || err);
  }
}

export function trackConversionEvent(eventName, props = {}) {
  if (!analyticsLoaded) return;
  if (!eventName) return;
  try {
    posthog.capture(eventName, props);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('[ANALYTICS] trackConversionEvent failed', err?.message || err);
  }
}
